import {
  Card,
  CardContent,
  Typography,
  MenuList,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
  CardActionArea,
  Avatar,
  CardMedia,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "./profile.css";
import { useNavigate } from "react-router-dom";
import getEventController from "../Controller/getEvent_controller";

//icon
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import NavigateNextOutlinedIcon from "@mui/icons-material/NavigateNextOutlined";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import DescriptionIcon from "@mui/icons-material/Description";
import GppGoodIcon from "@mui/icons-material/GppGood";
import ShareIcon from "@mui/icons-material/Share";
import LogoutIcon from "@mui/icons-material/Logout";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import card_background from "../../../images/PPKM_Background_Card2.png";
import PasswordIcon from "@mui/icons-material/Password";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import ppkm_logo from "../../../images/PPKM24.png";
import { QRCode } from "antd";
import { pdf } from "@react-pdf/renderer";
import ECert from "../../Admin/pdf/membership-cert.tsx";
import MembershipCertController from "../../Admin/Controller/ECert_controller.ts";
import SignatureController from "../../Admin/Controller/signature_controller.ts";

const Profile = () => {
  const navigate = useNavigate(); // Initialize useNavigate hook
  const memberId = localStorage.getItem("memberId");
  const email = localStorage.getItem("email");

  useEffect(() => {
    // const memberId = localStorage.getItem("memberId");
    // const email = localStorage.getItem("email");

    if (!memberId || !email) {
      // Clear localStorage and redirect to login
      localStorage.clear();
      navigate("/login");
    }
  }, [navigate]);

  //get Member Info
  useEffect(() => {
    getEventController
      .getMemberInfo(memberId, email)
      .then((response) => {
        console.log("API Response:", response); // Log to verify the response structure

        // Set eventData directly from the response object
        if (response) {
          setMemberInfo({
            membername: response.name,
            email: response,
            email,
            memberId: response,
            memberId,
            address: response.address,
            place_of_birth: response.place_of_birth,
            phone: response.handphone_no,
            race: response.race,
            gender: response.gender,
            nationality: response.nationality,
            marital_status: response.marital_status,
            academic_qualification: response.academic_qualification,
            office_email: response.office_email,
            office_tel: response.office_tel_no,
            fax_no: response.fax,
            nature_of_work: response.nature_of_work,
            years_with_company: response.years_with_company,
            profile_image: response.profile_image,
            userID: response.userID,
            company_name: response.company_name,
            max_term: response.max_term,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching member details:", error);
      });
  }, [memberId]);

  const [MemberInfo, setMemberInfo] = useState({
    memberId: memberId, // get memberId from local storage
    membername: "",
    email: email,
    address: "",
    place_of_birth: "",
    phone: "",
    race: "",
    gender: "",
    nationality: "",
    marital_status: "",
    academic_qualification: "",
    office_email: "",
    office_tel: "",
    fax: "",
    nature_of_work: "",
    years_with_company: "",
    max_term: "",
  });

  const handleLogout = () => {
    localStorage.removeItem("memberId");
    localStorage.removeItem("email");
    localStorage.removeItem("member_type");
    localStorage.removeItem("userId");
    localStorage.removeItem("committee_type");
    navigate("/login"); // Redirect to login page
  };

  const handleGenerateCert = async (memberID) => {
    try {
      const payload = new FormData();
      payload.append("memberID", memberID);

      const data = await MembershipCertController.getMembershipCertInfo(
        payload
      );
      const signatures = await SignatureController.getSignatures();

      const presidentData = signatures.find(
        (sig) => Number(sig.designation) === 0
      );
      const secretariatData = signatures.find(
        (sig) => Number(sig.designation) === 1
      );

      if (!presidentData?.signature_url || !secretariatData?.signature_url) {
        alert(
          "Cannot generate certificate.\nMissing president or secretary signature."
        );
        return;
      }

      const blob = await pdf(
        <ECert
          data={data}
          presidentData={presidentData}
          secretariatData={secretariatData}
        />
      ).toBlob();

      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");

      // Optional: If you want to revoke the URL after opening it
      // setTimeout(() => URL.revokeObjectURL(url), 5000);
    } catch (err) {
      console.error("Error generating PDF:", err);
      alert("Failed to generate e-certificate.\nPlease try again.");
    }
  };

  return (
    <div className="profile-list">
      {/*My Membership */}
      <div className="mb-4">
        <div>
          <span className="profile-label">My Membership</span>
        </div>
        <div className="member-card-row mt-2">
          {/* <img src={card_background} /> */}
          <CardActionArea
            sx={{ maxWidth: 420 }}
            onClick={() => navigate("/edit_profile")}
          >
            <CardMedia
              image={card_background}
              alt="Background"
              sx={{
                boxShadow: 5,
                objectFit: "cover", // Scale the image to fill the container
              }}
              className="d-flex member-card"
            >
              <CardContent>
                {MemberInfo.profile_image ? (
                  // If profile_image exists, render the image
                  <img
                    className="ur-avatar"
                    src={MemberInfo.profile_image}
                    alt="Profile"
                  />
                ) : (
                  // If profile_image is empty, render the MUI Avatar with fallback
                  <Avatar alt="Default Avatar" className="ur-avatar"></Avatar>
                )}
                {/* <img className="ur-avatar" src={MemberInfo.profile_image} /> */}
                <img className="ul-label" src={ppkm_logo}></img>
                <QRCode value={MemberInfo.userID} className="ur-qr" />
                <span className="ur-qr-label">{MemberInfo.userID}</span>
                <div className="bl-container">
                  <span className="bl-label">{MemberInfo.membername}</span>
                  <span className="bl-label1">{MemberInfo.company_name}</span>
                  <span className="bl-label1">
                    Mem. No.: {MemberInfo.memberId}
                  </span>
                </div>
                <div className="br-container">
                  <span className="br-label">
                    VALID THRU: {MemberInfo.max_term}
                  </span>
                </div>
              </CardContent>
            </CardMedia>
          </CardActionArea>
        </div>
      </div>

      {/*General Settings List */}
      <div className="mb-4">
        <div>
          <span className="profile-label">General Settings</span>
        </div>
        <div>
          <MenuList>
            {/* Membership Info */}
            <MenuItem
              className="mt-2"
              onClick={() => navigate("/edit_profile")}
            >
              <ListItemIcon>
                <EditNoteOutlinedIcon
                  fontSize="large"
                  className="profile-icon"
                />
              </ListItemIcon>
              <ListItemText className="profile-lbl">
                Manage Membership
              </ListItemText>
              <NavigateNextOutlinedIcon />
            </MenuItem>
            {/* Change Password */}
            <MenuItem
              className="mt-2"
              onClick={() => navigate("/change_password")}
            >
              <ListItemIcon>
                <VpnKeyIcon fontSize="large" className="profile-icon" />
              </ListItemIcon>
              <ListItemText className="profile-lbl">
                Change Password
              </ListItemText>
              <NavigateNextOutlinedIcon />
            </MenuItem>
            {/* 6-digit pin */}
            <MenuItem className="mt-2" onClick={() => navigate("/reset_pin")}>
              <ListItemIcon>
                <PasswordIcon fontSize="large" className="profile-icon" />
              </ListItemIcon>
              <ListItemText className="profile-lbl">
                Reset 6-Digits Pin
              </ListItemText>
              <NavigateNextOutlinedIcon />
            </MenuItem>
            {/* e-cert */}
            <MenuItem
              className="mt-2"
              onClick={() => handleGenerateCert(memberId)}
            >
              <ListItemIcon>
                <CardMembershipIcon fontSize="large" className="profile-icon" />
              </ListItemIcon>
              <ListItemText className="profile-lbl">E-Certificate</ListItemText>
              <NavigateNextOutlinedIcon />
            </MenuItem>
          </MenuList>
        </div>
      </div>

      {/*Information List */}
      <div className="mb-4">
        <div>
          <span className="profile-label">Information</span>
        </div>
        <div>
          <MenuList>
            {/* PPKM member directory */}
            <MenuItem
              className="mt-2"
              onClick={() => navigate("/members_list")}
            >
              <ListItemIcon>
                <Diversity3Icon fontSize="large" className="profile-icon" />
              </ListItemIcon>
              <ListItemText className="profile-lbl">PPKM Members</ListItemText>
              <NavigateNextOutlinedIcon />
            </MenuItem>
            {/* About App */}
            {/* <MenuItem className="mt-2">
              <ListItemIcon>
                <PhoneAndroidIcon fontSize="large" className="profile-icon" />
              </ListItemIcon>
              <ListItemText>About App</ListItemText>
              <NavigateNextOutlinedIcon />
            </MenuItem> */}
            {/* Terms & Conditions */}
            {/* <MenuItem className="mt-2">
              <ListItemIcon>
                <DescriptionIcon fontSize="large" className="profile-icon" />
              </ListItemIcon>
              <ListItemText>Terms & Conditions</ListItemText>
              <NavigateNextOutlinedIcon />
            </MenuItem> */}
            {/* Privacy Policy */}
            <MenuItem className="mt-2">
              <ListItemIcon>
                <GppGoodIcon fontSize="large" className="profile-icon" />
              </ListItemIcon>
              <ListItemText className="profile-lbl">
                Privacy Policy
              </ListItemText>
              <NavigateNextOutlinedIcon />
            </MenuItem>
            {/* Contact Us */}
            <MenuItem className="mt-2">
              <ListItemIcon>
                <ContactSupportIcon fontSize="large" className="profile-icon" />
              </ListItemIcon>
              <ListItemText className="profile-lbl">Contact Us</ListItemText>
              <NavigateNextOutlinedIcon />
            </MenuItem>
            <Divider />
            <MenuItem className="mt-2" onClick={() => handleLogout()}>
              <ListItemIcon>
                <LogoutIcon fontSize="large" className="profile-icon" />
              </ListItemIcon>
              <ListItemText>Logout</ListItemText>
            </MenuItem>
          </MenuList>
        </div>
      </div>
    </div>
  );
};

export default Profile;
